var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAi01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 183.35 186.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-10,.cls-3{opacity:0.2;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-24,.cls-8{mix-blend-mode:multiply;}.cls-20,.cls-21,.cls-23,.cls-8{opacity:0.5;}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:url(#linear-gradient-15);}.cls-17{fill:url(#linear-gradient-16);}.cls-18{fill:url(#linear-gradient-17);}.cls-19{fill:#fff;opacity:0.3;}.cls-20{fill:url(#linear-gradient-18);}.cls-21{fill:url(#linear-gradient-19);}.cls-22{fill:url(#linear-gradient-20);}.cls-23{fill:url(#linear-gradient-21);}.cls-24{opacity:0.35;}.cls-25{fill:url(#linear-gradient-22);}.cls-26{fill:url(#linear-gradient-23);}.cls-27{fill:#fb0050;}.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52{mix-blend-mode:screen;}.cls-28{fill:url(#radial-gradient);}.cls-29{fill:url(#radial-gradient-2);}.cls-30{fill:url(#radial-gradient-3);}.cls-31{fill:url(#radial-gradient-4);}.cls-32{fill:url(#radial-gradient-5);}.cls-33{fill:url(#radial-gradient-6);}.cls-34{fill:url(#radial-gradient-7);}.cls-35{fill:url(#radial-gradient-8);}.cls-36{fill:url(#radial-gradient-9);}.cls-37{fill:url(#radial-gradient-10);}.cls-38{fill:url(#radial-gradient-11);}.cls-39{fill:url(#radial-gradient-12);}.cls-40{fill:url(#radial-gradient-13);}.cls-41{fill:url(#radial-gradient-14);}.cls-42{fill:url(#radial-gradient-15);}.cls-43{fill:url(#radial-gradient-16);}.cls-44{fill:url(#radial-gradient-17);}.cls-45{fill:url(#radial-gradient-18);}.cls-46{fill:url(#radial-gradient-19);}.cls-47{fill:url(#radial-gradient-20);}.cls-48{fill:url(#radial-gradient-21);}.cls-49{fill:url(#radial-gradient-22);}.cls-50{fill:url(#radial-gradient-23);}.cls-51{fill:url(#radial-gradient-24);}.cls-52{fill:url(#radial-gradient-25);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 108.91,
    y1: 143.53,
    x2: 147.62,
    y2: 143.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8db0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8db0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#9dbce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#c6dcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cee2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 108.91,
    y1: 144.82,
    x2: 132.4,
    y2: 144.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1a83e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2f52d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3e2fc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#4719bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a11bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 82.32,
    y1: 162.47,
    x2: 122.78,
    y2: 122.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a11bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#390f9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#260d80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1b0c6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#170c66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 485.31,
    y1: 163.23,
    x2: 525.77,
    y2: 122.77,
    gradientTransform: "matrix(-1, 0, 0, 1, 639.16, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a11bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#370f9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#260d7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#1b0c6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#170c66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 131.04,
    y1: 148.69,
    x2: 95.53,
    y2: 113.18,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 72.52,
    y1: 169.51,
    x2: 111.24,
    y2: 130.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 80.12,
    y1: 136.65,
    x2: 101.49,
    y2: 136.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 58.06,
    y1: 127.35,
    x2: 144.62,
    y2: 40.8,
    gradientTransform: "matrix(0.99, 0.15, -0.15, 1.02, 16.8, -38.69)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 148.68,
    y1: 99.98,
    x2: 80.22,
    y2: 31.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 33.83,
    y1: 99.81,
    x2: 107.1,
    y2: 46.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9ceee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 58.64,
    y1: 140.99,
    x2: 62.35,
    y2: 140.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a148b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#4a13a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#4a11b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a11bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 78.79,
    y1: 130.93,
    x2: 82.5,
    y2: 130.93,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 95.05,
    y1: 114.96,
    x2: 98.76,
    y2: 114.96,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 90.81,
    y1: 25.74,
    x2: 94.52,
    y2: 25.74,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 83.68,
    y1: 6.09,
    x2: 87.39,
    y2: 6.09,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 38.75,
    y1: 63.97,
    x2: 51.67,
    y2: 76.88,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 36.93,
    y1: 65.2,
    x2: 47.4,
    y2: 75.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00c0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a11bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 33.06,
    y1: 58.64,
    x2: 64.62,
    y2: 58.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 26.27,
    y1: 123.74,
    x2: 35.6,
    y2: 123.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 20.09,
    y1: 111.96,
    x2: 25.26,
    y2: 106.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8db0e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8db0e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 31.05,
    y1: 134.79,
    x2: 36.9,
    y2: 128.94,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 86.43,
    y1: 96.22,
    x2: 146.49,
    y2: 36.17,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 91.04,
    y1: 91.61,
    x2: 141.88,
    y2: 40.78,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 384.82,
    cy: 422.88,
    r: 2.84,
    gradientTransform: "translate(526.58 -330.07) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#0088ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#005db2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#003172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00154a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#000a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#000a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00041a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#000107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 384.82,
    cy: 416.92,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 384.82,
    cy: 410.95,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 384.82,
    cy: 404.98,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 384.82,
    cy: 399.02,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 390.16,
    cy: 422.88,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 390.16,
    cy: 416.92,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 390.16,
    cy: 410.95,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 390.16,
    cy: 404.98,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 390.16,
    cy: 399.02,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 395.51,
    cy: 422.88,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 395.51,
    cy: 416.92,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 395.51,
    cy: 410.95,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 395.51,
    cy: 404.98,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 395.51,
    cy: 399.02,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 400.85,
    cy: 422.88,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 400.85,
    cy: 416.92,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 400.85,
    cy: 410.95,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 400.85,
    cy: 404.98,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 400.85,
    cy: 399.02,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 406.2,
    cy: 422.88,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 406.2,
    cy: 416.92,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 406.2,
    cy: 410.95,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 406.2,
    cy: 404.98,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 406.2,
    cy: 399.02,
    r: 2.84,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.76,177.69s18.26.89,21.81-2.13-5.16-5.74-3.45-22.67,10.5-43.64,10.5-43.64l-38.71,3.56s10.61,15.65,12.89,27.29S118.76,177.69,118.76,177.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.84,141.42c-2-11.16-10-25.61-12.27-29.59l-10.66,1s10.61,15.65,12.89,27.29-3,37.59-3,37.59,5.48.27,11,0C131.19,168.48,133.47,150.81,131.84,141.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.36,183.51a123.41,123.41,0,0,0,8.19-25,60.16,60.16,0,0,0-1-27c-1.6-5.2-1.4-7.2-8.59-19.19s-4.6-11.61-4.6-11.61l3.12-1s-.2,2.8,2.88,8.13c3.76,6.52,5.61,8.31,8.19,15,4.79,12.34,6.55,23,3.6,36.52-4.39,20.07-7,24.19-7,24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.81,184.26a123.41,123.41,0,0,1-8.19-25,60.18,60.18,0,0,1,1-27c1.6-5.19,1.4-7.19,8.59-19.18s4.6-11.62,4.6-11.62l-3.12-1s.2,2.8-2.88,8.13c-3.76,6.51-5.61,8.31-8.19,15-4.79,12.35-6.55,23-3.59,36.53,4.38,20.06,7,24.18,7,24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.4,130.93a25.12,25.12,0,1,1-25.12-25.11A25.12,25.12,0,0,1,138.4,130.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.63,178.22c7.5-.14,10.59.4,11.38-19.59s.24-24.45.24-30c0-4.14.86-6.68-5.09-6.94s-13.55-.06-15.55,1.94-2.4,5.8-2.8,17,.4,14.58-1.79,21.18-3.65,9.93-2.25,11.72C78.52,175.82,80.65,178.43,92.63,178.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M80.12,157.54s5.51,2.3,10.27-.87c5.44-3.63,7-7.85,9.41-17.53S101.31,115,101.31,115L83,120.74s-2.64,18.34-2.26,24A75.93,75.93,0,0,1,80.12,157.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M169.73,71.53c-4.6,31-26.77,55.13-68.18,45.39-32.35-7.6-62.3-12.77-63.3-67.2C37.67,18.41,76.48-1.16,109.39,3.36,148.76,8.75,174.33,40.56,169.73,71.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M164.28,65.75c0,25.93-22.31,46.94-49.83,46.94s-49.84-21-49.84-46.94,22.32-46.94,49.84-46.94S164.28,39.83,164.28,65.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M99.6,38.33c-.74-4.58-1.2-12-5.2-23C91.1,6.26,86.81,2.16,86.81,2.16A59.18,59.18,0,0,0,71.22,4.55a92.63,92.63,0,0,0-23.58,11.8c-6.33,4.39-14.63,14.18-19,21-4.1,6.39-5.8,18.18-3,23.58s3,5.52,3.2,8.79c.13,2-2.67,5.78-7.2,15.89-2.95,6.58-8.41,11.46-8.39,19.29a5.28,5.28,0,0,0,4,5.19,28.77,28.77,0,0,0,5.51.66c.94.12,1.73-.13,2.09.94.8,2.4-.63,7.69-.43,8.89s1.43,1.9,2.23,2.9,1.11,1.33,1,2.4c-.35,3.39,2,5.71,4.28,7a27.77,27.77,0,0,0-.69,6c.4,6.39,4.8,10.79,10,12.79s26-6.8,40.76-14.39,20.93-19.81,21.59-28.78C105,89.89,102.8,58.11,99.6,38.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M62.35,141a1.86,1.86,0,1,1-1.86-1.85A1.86,1.86,0,0,1,62.35,141Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M82.5,130.93a1.86,1.86,0,1,1-1.85-1.85A1.85,1.85,0,0,1,82.5,130.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M98.76,115a1.86,1.86,0,1,1-1.86-1.86A1.85,1.85,0,0,1,98.76,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M94.52,25.74a1.86,1.86,0,1,1-1.86-1.86A1.85,1.85,0,0,1,94.52,25.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M87.39,6.09a1.86,1.86,0,1,1-1.85-1.85A1.85,1.85,0,0,1,87.39,6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M36.56,75.34c2.87,4.3,4.17,3.18,9.86,0a85.65,85.65,0,0,1,12.22-5.43S51,66.08,47,65.13s-7.17-2.55-9.4,0S35,73,36.56,75.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M36.33,75.34c2.19,4.3,3.18,3.18,7.51,0a58.59,58.59,0,0,1,9.32-5.43s-5.83-3.83-8.87-4.78-5.46-2.55-7.17,0S35.12,73,36.33,75.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M39.23,71.18c0,2.42-.81,4.38-1.81,4.38s-1.82-2-1.82-4.38.81-4.38,1.82-4.38S39.23,68.76,39.23,71.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M29.53,51.94s9.56,1.09,17.7-7.52S57.72,33.25,60.49,27.59s3.38-11.49,1.86-12.91c-3.05-2.84-7.57-3.64-12.42,0S30.63,29.22,26.57,41.53c-2.64,8-2.49,7.5-1.41,9S29.53,51.94,29.53,51.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M32,99.79c-.27,4.49,7.78-.36,9.69-3.29C44.76,91.75,54.5,85.36,56.7,83s6.37-9.69,5.65-10-5.92,6.32-10.87,8.09S42,82.34,39.57,82.33C37.41,82.33,32.23,95.3,32,99.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M39.82,151A16.4,16.4,0,0,1,33,144.76c-2.27-3.63-1.73-4.83-1.73-5.91s3.46-2.47,4.28-1.21.07,2.65,1.58,5.93,2.37,4.12,2.71,5.29C40.44,151,39.82,151,39.82,151Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M13.72,105.83s.33.44,1-1.86,2.63-3.88,1.37-4.76-1.77.33-1.77.33-1.65,4.95-1.12,5.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "24.43 120.56 29.55 119.11 28.44 114.96 24.91 116.19 24.43 120.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M33.06,58.33S39.23,57,47,55.54c8-1.46,11.49-.58,13.51,0s3.49,3.34,4.07,4.15-3.45-2.48-8-2.74c-8.93-.5-23.46,5.58-23.46,5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M26.27,123l9.33-1.4-7.94,4.23a5,5,0,0,0-.2-1.32A14.51,14.51,0,0,0,26.27,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M18.44,110.31l7.83-2.5-1.84,3.12s-3.07-.25-3.91-.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "31.94 132.86 37.41 129.45 31.2 134.94 31.94 132.86"
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-24",
    width: 116,
    height: 116,
    transform: "translate(59 9.42)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M158.92,66.2a42.47,42.47,0,1,1-42.46-42.47A42.46,42.46,0,0,1,158.92,66.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M152.4,66.2a35.95,35.95,0,1,1-35.94-35.95A35.94,35.94,0,0,1,152.4,66.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M116.46,39.18a27,27,0,1,0,27,27A27,27,0,0,0,116.46,39.18Zm0,48.65A21.64,21.64,0,1,1,138.09,66.2,21.63,21.63,0,0,1,116.46,87.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M105.71,56.75a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,105.71,56.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M111.68,56.75a2.84,2.84,0,1,0-4,0A2.85,2.85,0,0,0,111.68,56.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M117.64,56.75a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,117.64,56.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M123.61,56.75a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,123.61,56.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M129.57,56.75a2.84,2.84,0,1,0-4,0A2.83,2.83,0,0,0,129.57,56.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M105.71,62.1a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,105.71,62.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M111.68,62.1a2.84,2.84,0,1,0-4,0A2.85,2.85,0,0,0,111.68,62.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M117.64,62.1a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,117.64,62.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M123.61,62.1a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,123.61,62.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M129.57,62.1a2.84,2.84,0,1,0-4,0A2.83,2.83,0,0,0,129.57,62.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M105.71,67.44a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,105.71,67.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M111.68,67.44a2.84,2.84,0,1,0-4,0A2.85,2.85,0,0,0,111.68,67.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M117.64,67.44a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,117.64,67.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M123.61,67.44a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,123.61,67.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M129.57,67.44a2.84,2.84,0,1,0-4,0A2.83,2.83,0,0,0,129.57,67.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M105.71,72.79a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,105.71,72.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M111.68,72.79a2.84,2.84,0,1,0-4,0A2.85,2.85,0,0,0,111.68,72.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M117.64,72.79a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,117.64,72.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M123.61,72.79a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,123.61,72.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M129.57,72.79a2.84,2.84,0,1,0-4,0A2.83,2.83,0,0,0,129.57,72.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M105.71,78.13a2.84,2.84,0,1,0-4,0A2.83,2.83,0,0,0,105.71,78.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M111.68,78.13a2.84,2.84,0,1,0-4,0A2.84,2.84,0,0,0,111.68,78.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M117.64,78.13a2.84,2.84,0,1,0-4,0A2.83,2.83,0,0,0,117.64,78.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M123.61,78.13a2.84,2.84,0,1,0-4,0A2.83,2.83,0,0,0,123.61,78.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M129.57,78.13a2.84,2.84,0,0,0-4-4,2.84,2.84,0,1,0,4,4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi01);
export default __webpack_public_path__ + "static/media/Ai-01.45333b76a97964793ecdadec19fdd32c.svg";
export { ForwardRef as ReactComponent };